<div class="playground-container">
  <div class="playground-header">
    <div class="left-section">
      <div class="test-results-navigation" *ngIf="playgroundService.playgroundStage === 'results'"
        [class.disabled]="playgroundService.playgroundResultStatus === 'inProgress'"
        [style.pointer-events]="playgroundService.playgroundResultStatus === 'inProgress' ? 'none' : 'auto'">
        <div class="back-button" (click)="handleTestResultNavigation()">
          <img src="assets/icons/playground_go_back.svg" alt="go_back">
        </div>
        <span class="test-results-text">Test Results</span>
      </div>
    </div>

    <div class="right-section" *ngIf="playgroundService.playgroundStage === 'input'">
      <!-- Button is only shown when not in 'hide' state -->
      <button *ngIf="playgroundService.runTestBtnFlag !== 'hide'" class="btn-run-test"
        [disabled]="playgroundService.runTestBtnFlag === 'disable'" (click)="handleRunTest()">
        Run Test
        <img [src]="
      playgroundService.runTestBtnFlag === 'enable'
        ? 'assets/icons/arrow_green.svg'
        : 'assets/icons/arrow_grey.svg'
    " alt="run_test" />
      </button>
    </div>

    <div class="right-section-status" *ngIf="playgroundService.playgroundStage === 'results'">
      <!-- Processing icon: Show when insight generation is not completed -->
      <img *ngIf="!insightGenerationCompleted" src="assets/icons/playground-processing.svg" alt="processing-icon">

      <!-- Processed icon: Show when insight generation is completed -->
      <img *ngIf="insightGenerationCompleted" src="assets/icons/playground-processed.svg" alt="Processed-icon">

      <div class="polling-status">
        <span class="done-class">{{ (playgroundService.statusCounts$ | async)?.done || 0 }}</span> / <span>{{
          (playgroundService.statusCounts$ | async)?.total || 0 }}</span> Processed
      </div>

      <!-- Failed section: Show only if there are failed items -->
      <div class="failed-class" *ngIf="failedCount > 0">
        <div class="segment-dash"></div>
        <img src="assets/icons/playground-failed.svg" alt="failed-icon">
        <div>
          <span class="done-class">{{ failedCount }}</span><span class="polling-status"> Failed</span>
        </div>
      </div>
    </div>
  </div>
  <div class="playground-body">
    @if(playgroundService.playgroundStage === 'input'){
    <app-playground-input></app-playground-input>
    } @else if(playgroundService.playgroundStage === 'results'){
    <app-playground-results></app-playground-results>
    }
  </div>
</div>

<div class="modal-overlay" *ngIf="showStopProcessingPopup">
  <div class="modal-content">
    <div class="modal-header">
      <img src="assets/icons/warning-popup.svg" alt="warning -icon" class="warning-icon">
      <span class="message">Are you sure you want to stop?</span>
    </div>
    <p>This will stop processing all test results in the playground. Any ongoing analysis will be halted and you might
      need to restart it later.</p>
    <div class="modal-actions">
      <button class="btn-stop-processing" (click)="stopProcessingAndNavigateBack()">Stop Processing</button>
      <button class="btn-cancel" (click)="cancelStopProcessing()">Cancel</button>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showClearDataPopup">
  <div class="modal-content">
    <div class="modal-header">
      <img src="assets/icons/warning-popup.svg" alt="warning -icon" class="warning-icon">
      <span class="message">Clear Processed Data?</span>
    </div>
    <p>This will clear all processed test results from the playground. You will need to run the test again to see the
      results.</p>
    <div class="modal-actions">
      <button class="btn-stop-processing" (click)="clearDataAndNavigateBack()">Clear & Go Back</button>
      <button class="btn-cancel" (click)="cancelClearData()">Cancel</button>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showTaxonomyChangePopup">
  <div class="modal-content">
    <div class="modal-header">
      <img src="assets/icons/warning-popup.svg" alt="warning -icon" class="warning-icon">
      <span class="message">Stop Processing?</span>
    </div>
    <p>Changing taxonomy or version will stop the current processing. Are you sure you want to proceed?</p>
    <div class="modal-actions">
      <button class="btn-stop-processing" (click)="stopProcessingForTaxonomyChange()">Stop & Change</button>
      <button class="btn-cancel" (click)="cancelTaxonomyChange()">Cancel</button>
    </div>
  </div>
</div>
